// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5271) return "5271.90607d61f435ccb74527.js";
	// return url for filenames based on template
	return "" + {"1167":"905081628f18bf4da9c4","3167":"2005c286526f2b4611c4"}[chunkId] + ".js";
};